import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { NotificationsViewService } from '@modules/private/omnichannel/data/services/view/notifications-view.service'
import { INotification } from '@modules/private/omnichannel/data/interfaces/notification.interface'

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
})
export class NotificationBellComponent implements OnInit {
  unread$ = this.viewService.unread$
  list$ = this.viewService.list$

  constructor(private viewService: NotificationsViewService, private router: Router) {}

  ngOnInit(): void {
    this.viewService.startPolling() //* polling 30s + visibilitychange (idempotente)
  }

  onPanelShow(): void {
    this.viewService.loadList()
  }

  open(n: INotification): void {
    this.viewService.markRead(n._id)
    //* deep-link según el payload del motor compartido (PRD §6.1)
    if (n.payload?.['activityId']) this.router.navigate(['/funnel-tasks'])
    else if (n.payload?.['clientId']) this.router.navigate(['/customer', n.payload['clientId']])
  }

  markAll(): void {
    this.viewService.markAllRead()
  }
}
